export default Object.freeze({
  // @deprecated
  // locales config has been moved to API settings endpoint
  locales: ['nl', 'fr', 'en'],

  fallbackLocale: 'en',
  defaultLocale: 'nl',
});
